import { Divider, Link, Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import { BsTwitterX } from "react-icons/bs";
import { FaFacebook, FaLink, FaTwitter, FaWhatsapp } from "react-icons/fa";
import { TwitterIcon } from "react-share";

const socials = [
  //   {
  //     id: "facebook",
  //     icon: <FaFacebook size={24} />,
  //     label: "فيسبوك",
  //   },
  {
    id: "whatsapp",
    icon: <FaWhatsapp size={18} />,
    label: "واتساب",
  },
  {
    id: "x",
    icon: <BsTwitterX size={18} />,
    label: "اكس",
  },
  {
    id: "copy",
    icon: <FaLink size={18} />,
    label: "نسخ",
  },
];

export default function ShareDialog() {
  return (
    <Stack>
      <Typography variant="h6" textAlign="center" fontWeight={400} mb={3}>
        استمتعت بالفيديو؟ شاركه مع من تحب واجعل لحظات الفرح تزداد
      </Typography>
      <Divider />
      <Stack>
        {socials.map(({ id, icon, label, formattedUrl }) => (
          <ShareButton key={id} icon={icon} label={label} id={id} />
        ))}
      </Stack>
    </Stack>
  );
}
function formatUrl(social, message, url) {
  switch (social) {
    case "facebook":
      return `https://www.facebook.com/sharer/sharer.php?u=${url}`;

    case "whatsapp":
      return `https://wa.me/?text=${message}`;

    case "x":
      return `https://x.com/intent/post?text=${message}`;
    default:
      return "";
  }
}
function ShareButton({ id, icon, label }) {
  const [copy, setCopy] = useState(false);

  const handleShare = () => {
    let url = window.location.href;
    const message = encodeURIComponent(url);

    if (id === "copy") {
      navigator.clipboard.writeText(url).then(() => {
        setCopy(true);
        setTimeout(() => {
          setCopy(false);
        }, 3000);
      });
    } else {
      window.open(formatUrl(id, message, url), "_blank");
    }
  };

  return (
    <Stack>
      <Stack
        component={Link}
        color="black"
        underline="none"
        flexDirection="row"
        alignItems="center"
        gap={{ xs: 3, md: 5 }}
        my={1.5}
        onClick={handleShare}
        sx={{
          ":hover": {
            cursor: "pointer",
          },
        }}
      >
        {icon}
        <Typography variant="h6" fontWeight={400}>
          {copy && id === "copy" ? "! نسخت" : label}
        </Typography>
      </Stack>
      <Divider />
    </Stack>
  );
}
